import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Divider,
  Box,
  CircularProgress,
} from '@material-ui/core';
import {
  Details,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@material-ui/icons';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ReactSelect from 'react-select';
import { useStyles } from './styles';
import ArrowIcon from '../../../assets/icons/arrow.png';
import Service from '../Service'
import { isYieldExpression } from 'typescript';
import axiosInstance from '../../../environment/axiosInstance'
import { HiArrowNarrowRight } from 'react-icons/hi';
import { Link, useHistory } from 'react-router-dom';
import { connected } from 'process';

export function DepartmentStats(props: any): JSX.Element {
  const classes = useStyles();
  const history = useHistory()
  const [alignment, setAlignment] = React.useState<string | null>('left');
  const [value, setValue] = React.useState(null);
  const [childRow, setChildRow] = React.useState(false);
  const [childOpenRow, setChildOpenRow] = React.useState(false);
  const [childCloseRow, setChildCloseRow] = React.useState(false);
  const [allData, setAllData] = React.useState<any>([])
  const [allUserData, setAllUserData] = React.useState<any>([])
  const [allSummary, setAllSummary] = React.useState<any>({})
  const [openSummary, setOpenSummary] = React.useState<any>({})
  const [closeSummary, setCloseSummary] = React.useState<any>({})
  const [openData, setOpenData] = React.useState<any>([])
  const [openUserData, setOpenUserData] = React.useState<any>([])
  const [closeData, setCloseData] = React.useState<any>([])
  const [closeUserData, setCloseUserData] = React.useState<any>([])
  const [tabVal, setTabVal] = React.useState("1")
  const [type, setype] = React.useState<any>(1)
  const [id, setId] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const handleAlignment = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {
    setAlignment(newAlignment);
  };


  const keyOptions = [
    { label: "Today", value: 1 },
    { label: "Yesterday", value: 2 },
    { label: "Last 7 days", value: 3 },
    { label: "Last 30 days", value: 4 },

  ]
  const handleOptions = (e: any) => {
    localStorage.setItem('dbDeptStats', e.value)
    setype(e.value)
    if (tabVal === "1") {
      alldepartmentsStatsData(e.value)
    }
    else if (tabVal === "2") {
      fetchopenHoursData(e.value, 1)
    }
    else if (tabVal === "3") {
      fetchCloseHoursData(e.value, 2)
    }

  }

  const handleChildRow = (id: any) => {
    setId(id)
    setChildRow(!childRow)
    // alldepartmentsStatsData(type)
  }
  const handleOpenChildRow = (id: any) => {
    setId(id)
    setChildOpenRow(!childOpenRow)
    // fetchopenHoursData(type, 1)
  }
  const handleCloseChildRow = (id: any) => {
    setId(id)
    setChildCloseRow(!childCloseRow)
    // fetchCloseHoursData(type, 2)
    // getDepartmentUsercloseStats(type, 2, id)
  }



  //newapi integrations
  const handleTabValue = (val: any) => {
    setTabVal(val)
    if (val === "1") {
      alldepartmentsStatsData(type)
    }
    else if (val === "2") {
      fetchopenHoursData(type, 1)
    }
    else if (val === "3") {
      fetchCloseHoursData(type, 2)
    }
  }
  const handleChange = (value: any) => {
    setValue(value);
  };

  const officeId = localStorage.getItem('SelectedCompanyId')
  const [deptName, setDeptName] = React.useState<any>([])
  const alldepartmentsStatsData = (type: any) => {
    setLoading(true)
    let url = `/dashboard/department-stats?type=${type}`
    if (officeId) {
      url = `/dashboard/department-stats?type=${type}&officeId=${officeId}`
    }
    axiosInstance.get(url).then((res: any) => {
      if (res.status === 200) {
        setLoading(false)
        const data = res.data.data
        setAllSummary(res.data.summary)
        setDeptName(data)
        // const usersDataa = res.data.data[0].usersStats
        // setUsersData(usersDataa)

      }
    }).catch((err: any) => {
      setLoading(false)
    })
  }

  //openhours data
  const [openDepts, setOpenDepts] = React.useState([])
  const fetchopenHoursData = (type: any, val: any) => {
    setLoading(true)
    let url = `/dashboard/department-stats?type=${type}&hourType=${val}`
    if (officeId) {
      url = `/dashboard/department-stats?type=${type}&hourType=${val}&officeId=${officeId}`
    }
    axiosInstance.get(url).then((res: any) => {
      if (res.status === 200) {
        setLoading(false)
        const dataa = res.data.data
        setOpenDepts(dataa)
        // const data = res.data.data[0].usersStats
        // console.log('open', data)
        // setOpenHoursData(data)
      }
    }).catch((err: any) => {
      setLoading(false)
    })
  }

  //closehours Data
  const [clsDeptName, setClsDeptName] = React.useState([])
  const fetchCloseHoursData = (type: any, val: any) => {
    setLoading(true)
    let url = `/dashboard/department-stats?type=${type}&hourType=${val}`
    if (officeId) {
      url = `/dashboard/department-stats?type=${type}&hourType=${val}&officeId=${officeId}`
    }
    axiosInstance.get(url).then((res: any) => {
      if (res.status === 200) {
        setLoading(false)
        const data = res.data.data
        setClsDeptName(data)
      }

    }).catch((err: any) => {
      setLoading(false)
    })
  }


  // React.useEffect(() => {
  //   alldepartmentsStatsData(type)
  //   fetchopenHoursData(type, 1)
  //   fetchCloseHoursData(type, 2)
  // }, [])

  //all departmenData
  React.useEffect(() => {
    let lType: any = 1;

    if (localStorage.getItem('dbDeptStats')) {
      const getValues: any = localStorage.getItem('dbDeptStats');
      setype(parseInt(getValues));
      lType = parseInt(getValues)
    }
    alldepartmentsStatsData(lType)
    if (tabVal === "2") {
      fetchopenHoursData(type, 1)
    }
    if (tabVal === "3") {
      fetchCloseHoursData(type, 2)
    }
  }, [])

  // React.useEffect(() => {
  //   if (tabVal === "1") {
  //     alldepartmentsStatsData(type)
  //   }
  //   else if (tabVal === "2") {
  //     fetchopenHoursData(type, 1)
  //   }
  //   else if (tabVal === "3") {
  //     fetchCloseHoursData(type, 2)
  //   }
  // }, [])



  const postData = (id: any, incoming: any, outgoing: any) => {
    const url = `/dashboard/allreports?departmentId=${id}&type=${type}`
    window.open(url, "_blank")
  }

  //all
  //outgoing
  const outgoingRedirectNextPage = (id: any, outgoing: any, total: any, connected: any) => {
    if (total === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${outgoing?.callDirection}&total=1`
      window.open(url, "_blank")
    } else if (connected === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${outgoing?.callDirection}&connected=1`
      window.open(url, "_blank")
    }

  }

  //incoming
  const incomingRedirectNextPage = (id: any, incoming: any, total: any, connected: any) => {
    if (total === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${incoming?.callDirection}&total=1`
      window.open(url, "_blank")
    } else if (connected === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${incoming?.callDirection}&connected=1`
      window.open(url, "_blank")
    }
  }

  //end

  // openhours
  //outgoing
  const openHoursOutgoingNextPage = (id: any, outgoing: any, total: any, connected: any) => {
    if (total === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${outgoing?.callDirection}&total=1`
      window.open(url, "_blank")
    } else if (connected === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${outgoing?.callDirection}&connected=1`
      window.open(url, "_blank")
    }
  }

  //incomig
  const openHoursIncomingRedirectNextPage = (id: any, incomig: any, total: any, connected: any) => {
    if (total === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${incomig?.callDirection}&total=1`
      window.open(url, "_blank")
    } else if (connected === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${incomig?.callDirection}&connected=1`
      window.open(url, "_blank")
    }
  }

  //end

  //closehours
  //outgoing
  const closeHoursOutgoingNextPage = (id: any, outgoing: any, total: any, connected: any) => {
    if (total === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${outgoing?.callDirection}&total=1`
      window.open(url, "_blank")
    } else if (connected === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${outgoing?.callDirection}&connected=1`
      window.open(url, "_blank")
    }
  }
  //incomig
  const closeHoursIncomingRedirectNextPage = (id: any, incomig: any, total: any, connected: any) => {
    if (total === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${incomig?.callDirection}&total=1`
      window.open(url, "_blank")
    } else if (connected === 1) {
      const url = `/dashboard/allreports?departmentId=${id}&type=${type}&callDirection=${incomig?.callDirection}&connected=1`
      window.open(url, "_blank")
    }
  }

  //end

  return (
    <>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={5} className={classes.cardContent}>
            <Grid item md={3} sm={3} className={classes.grid}>
              <Typography className={classes.userText}>Department Stats</Typography>
            </Grid>
            <Grid item md={6} sm={6} xs={12} className={classes.gridItem}>
              <ToggleButtonGroup value={alignment} exclusive onChange={handleAlignment}>
                <ToggleButton className={classes.button} value="left" onClick={() => handleTabValue("1")}>
                  <Typography className={classes.toggleText}>All</Typography>
                </ToggleButton>
                <ToggleButton className={classes.button} value="center" onClick={() => handleTabValue("2")}>
                  <Typography className={classes.toggleText}>Open Hours</Typography>
                </ToggleButton>
                <ToggleButton className={classes.button} value="right" onClick={() => handleTabValue("3")}>
                  <Typography className={classes.toggleText}>Close Hours</Typography>
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item md={3} sm={3} xs={12} className={`classes.gridItem ${classes.width}`}>
              <ReactSelect placeholder={'Today'} options={keyOptions}
                onChange={handleOptions}
                value={keyOptions.filter((opt: any) => opt.value === type)} />
            </Grid>
          </Grid>
        </CardContent>
        <Divider style={{ marginTop: -5 }} />
        {loading ?
          <Box>
            <div style={{ width: "100%", textAlign: "center" }}>
              <CircularProgress />
            </div>
          </Box>
          :
          <>
            {tabVal === "1" ?
              <CardContent>
                <TableContainer component={Card} className={classes.tableContainer} id="tableWidthDashboard">
                  <Table className={classes.table}>
                    <TableHead className={classes.tableHead}>
                      <TableRow>
                        <TableCell className={classes.tableCell} rowSpan={2} align="center">
                          Departments
                        </TableCell>
                        <TableCell className={classes.tableCell} colSpan={2} align="center">
                          Outgoing
                        </TableCell>
                        <TableCell className={classes.tableCell} colSpan={3} align="center">
                          Incoming
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.tableCell} align="center">
                          Total
                          <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                          connected
                          <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                          Total
                          <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                          connected
                          <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                          Missed
                          <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {
                      deptName && deptName?.map((item: any) => {
                        return (
                          <>
                            <TableHead className={classes.tableHeader}>
                              <TableRow>
                                <TableCell className={classes.tableCellRow} >
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                    <HiArrowNarrowRight style={{ color: '#4D72F8', cursor: 'pointer' }}
                                      onClick={() => postData(item._id, item.incomingDeptStats, item.outgoingDeptStats)}
                                    />
                                    <div style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}>
                                      {item.name}
                                      {childRow && id === item.name ? (
                                        <KeyboardArrowUp onClick={() => handleChildRow(item.name)} />
                                      ) : (
                                        <KeyboardArrowDown onClick={() => handleChildRow(item.name)} />
                                      )}
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center"
                                  onClick={() => outgoingRedirectNextPage(item._id, item.outgoingDeptStats, 1, 0)}
                                >
                                  {item.outgoingDeptStats?.total}
                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center"
                                  onClick={() => outgoingRedirectNextPage(item._id, item.outgoingDeptStats, 0, 1)}
                                >
                                  {item.outgoingDeptStats?.connected}
                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center"
                                  onClick={() => incomingRedirectNextPage(item._id, item.incomingDeptStats, 1, 0)}
                                >
                                  {item.incomingDeptStats?.total}
                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center"
                                  onClick={() => incomingRedirectNextPage(item._id, item.incomingDeptStats, 0, 1)}
                                >
                                  {item.incomingDeptStats?.connected}

                                  {/* <img className={classes.addIcon} src={ArrowIcon} alt="arrow" /> */}
                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center">
                                  {item.incomingDeptStats?.missed}
                                  {/* <img className={classes.addIcon} src={ArrowIcon} alt="arrow" /> */}
                                </TableCell>
                              </TableRow>

                            </TableHead>
                            {childRow && (id === item.name) &&
                              < TableBody >
                                {item.userStats && item.userStats?.map((detail: any) => {
                                  return (
                                    <>
                                      <TableRow key={detail.name}>
                                        <TableCell className={classes.tableCellBody}>{detail?.firstName} {detail?.lastName}</TableCell>
                                        <TableCell className={classes.tableCellBody}>{detail.outgoingStats?.total}</TableCell>
                                        <TableCell className={classes.tableCellBody} >
                                          <div>

                                            {detail.outgoingStats?.connected}
                                            <div>
                                              <Typography style={{ color: "gray", fontSize: "9px" }}>{detail.outbound?.outboundDuration}</Typography>
                                            </div>
                                          </div>
                                        </TableCell>
                                        <TableCell className={classes.tableCellBody}>{detail.incomingStats?.total}</TableCell>
                                        <TableCell className={classes.tableCellBody}>
                                          <div>
                                            {detail.incomingStats?.connected}

                                            <div>
                                              <Typography style={{ color: "gray", fontSize: "9px" }}>{detail.inbound?.inboundDuration}</Typography>
                                            </div>
                                          </div>
                                        </TableCell>
                                        <TableCell className={classes.tableCellBody}>
                                          {detail.incomingStats?.missed}
                                          {/* ({detail.inbound?.missedCallPercentage}%) */}
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  );
                                })
                                }
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                  {deptName?.length <= 0 &&
                                    <p style={{ textAlign: "center", marginRight: '90px', fontSize: 14, fontWeight: 500, marginTop: 2, marginBottom: 0 }}> No Data found</p>}
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                              </TableBody>
                            }
                          </>
                        )
                      })
                    }
                    {deptName?.length > 0 && <TableHead className={classes.tableHead}>
                      <TableRow>
                        <TableCell className={classes.tableCellRow} align="center">
                          Summary
                        </TableCell>
                        <TableCell className={classes.tableCellRow} align="center">
                          {allSummary?.outgoingStats?.total}
                        </TableCell>
                        <TableCell className={classes.tableCellRow} align="center">
                          {allSummary?.outgoingStats?.connected}
                        </TableCell>
                        <TableCell className={classes.tableCellRow} align="center">
                          {allSummary?.incomingStats?.total}
                        </TableCell>
                        <TableCell className={classes.tableCellRow} align="center">
                          {allSummary?.incomingStats?.connected}
                        </TableCell>
                        <TableCell className={classes.tableCellRow} align="center">
                          {allSummary?.incomingStats?.missed}
                        </TableCell>
                      </TableRow>

                    </TableHead>
                    }
                  </Table>
                  {deptName?.length <= 0 &&
                    <p style={{ textAlign: "center", fontSize: 18, fontWeight: 500, marginTop: 10 }}> No Data found</p>
                  }
                </TableContainer>
              </CardContent>
              :
              tabVal === "2" ?
                <CardContent>
                  <TableContainer component={Card} className={classes.tableContainer} id="tableWidthDashboard">
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHead}>
                        <TableRow>
                          <TableCell className={classes.tableCell} rowSpan={2} align="center">
                            Departments
                          </TableCell>
                          <TableCell className={classes.tableCell} colSpan={2} align="center">
                            Outgoing
                          </TableCell>
                          <TableCell className={classes.tableCell} colSpan={3} align="center">
                            Incoming
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.tableCell} align="center">
                            Total
                            <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                          </TableCell>
                          <TableCell className={classes.tableCell} align="center">
                            connected
                            <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                          </TableCell>
                          <TableCell className={classes.tableCell} align="center">
                            Total
                            <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                          </TableCell>
                          <TableCell className={classes.tableCell} align="center">
                            connected
                            <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                          </TableCell>
                          <TableCell className={classes.tableCell} align="center">
                            Missed
                            <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {openDepts && openDepts?.map((item: any) => {
                        return (
                          <>
                            <TableHead className={classes.tableHeader}>
                              <TableRow>
                                <TableCell className={classes.tableCellRow}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                    <HiArrowNarrowRight style={{ color: '#4D72F8', cursor: 'pointer' }}
                                      onClick={() => postData(item._id, item.incomingDeptStats, item.outgoingDeptStats)}
                                    />
                                    <div style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}>
                                      {item.name}
                                      {childOpenRow && (item.name === id) ? (
                                        <div><KeyboardArrowDown onClick={() => handleOpenChildRow(item.name)} /></div>
                                      ) : (
                                        <KeyboardArrowUp onClick={() => handleOpenChildRow(item.name)} />
                                      )}
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center"
                                  onClick={() => openHoursOutgoingNextPage(item._id, item.outgoingDeptStats, 1, 0)}
                                >
                                  {item.outgoingDeptStats?.total}
                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center"
                                  onClick={() => openHoursOutgoingNextPage(item._id, item.outgoingDeptStats, 0, 1)}
                                >
                                  {item.outgoingDeptStats?.connected}

                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center"
                                  onClick={() => openHoursIncomingRedirectNextPage(item._id, item.incomingDeptStats, 1, 0)}
                                >
                                  {item.incomingDeptStats?.total}
                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center"
                                  onClick={() => openHoursIncomingRedirectNextPage(item._id, item.incomingDeptStats, 0, 1)}
                                >
                                  {item.incomingDeptStats?.connected}
                                  {/* <img className={classes.addIcon} src={ArrowIcon} alt="arrow" /> */}
                                </TableCell>
                                <TableCell className={classes.tableCellRow} align="center">
                                  {item.incomingDeptStats?.missed}
                                  {/* <img className={classes.addIcon} src={ArrowIcon} alt="arrow" /> */}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            {childOpenRow && (id === item.name) &&
                              < TableBody >
                                {item.userStats && item.userStats?.map((detail: any) => {
                                  return (
                                    <>
                                      <TableRow key={detail.name}>
                                        <TableCell className={classes.tableCellBody}>{detail.firstName} {detail.lastName}</TableCell>
                                        <TableCell className={classes.tableCellBody}>{detail.outgoingStats?.total}</TableCell>
                                        <TableCell className={classes.tableCellBody} >
                                          <div>
                                            {detail.outgoingStats?.connected}
                                            <div>
                                              <Typography style={{ color: "gray", fontSize: "9px" }}>{detail.outbound?.outboundDuration}</Typography>
                                            </div>
                                          </div>
                                        </TableCell>
                                        <TableCell className={classes.tableCellBody}>{detail.incomingStats?.total}</TableCell>
                                        <TableCell className={classes.tableCellBody}>
                                          <div>
                                            {detail.incomingStats?.connected}

                                            <div>
                                              <Typography style={{ color: "gray", fontSize: "9px" }}>{detail.inbound?.inboundDuration}</Typography>
                                            </div>
                                          </div>
                                        </TableCell>
                                        <TableCell className={classes.tableCellBody}>
                                          {detail.incomingStats?.missed}
                                          {/* ({detail.inbound?.missedCallPercentage}%) */}
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  );
                                })
                                }
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                  {openDepts?.length <= 0 &&
                                    <p style={{ textAlign: "center", marginRight: '90px', fontSize: 14, fontWeight: 500, marginTop: 2, marginBottom: 0 }}> No Data found</p>}
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                              </TableBody>
                            }
                          </>
                        )
                      })}
                      {openDepts?.length > 0 && <TableHead className={classes.tableHead}>
                        <TableRow>
                          <TableCell className={classes.tableCellRow} align="center">
                            Summary
                          </TableCell>
                          <TableCell className={classes.tableCellRow} align="center">
                            {openSummary?.totalOutbound}
                          </TableCell>
                          <TableCell className={classes.tableCellRow} align="center">
                            {openSummary?.totalOutboundConnected}
                          </TableCell>
                          <TableCell className={classes.tableCellRow} align="center">
                            {openSummary?.totalInbound}
                          </TableCell>
                          <TableCell className={classes.tableCellRow} align="center">
                            {openSummary?.totalInboundConnected}
                          </TableCell>
                          <TableCell className={classes.tableCellRow} align="center">
                            {openSummary?.totalMissedCalls}
                          </TableCell>
                        </TableRow>

                      </TableHead>
                      }


                    </Table>
                    {openDepts?.length <= 0 &&
                      <p style={{ textAlign: "center", fontSize: 14, fontWeight: 500, marginTop: 10 }}> No Data found</p>
                    }
                  </TableContainer>
                </CardContent>
                :
                tabVal === "3" ?
                  <CardContent>
                    <TableContainer component={Card} className={classes.tableContainer} id="tableWidthDashboard">
                      <Table className={classes.table}>
                        <TableHead className={classes.tableHead}>
                          <TableRow>
                            <TableCell className={classes.tableCell} rowSpan={2} align="center">
                              Departments
                            </TableCell>
                            <TableCell className={classes.tableCell} colSpan={2} align="center">
                              Outgoing
                            </TableCell>
                            <TableCell className={classes.tableCell} colSpan={3} align="center">
                              Incoming
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className={classes.tableCell} align="center">
                              Total
                              <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                            </TableCell>
                            <TableCell className={classes.tableCell} align="center">
                              connected
                              <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                            </TableCell>
                            <TableCell className={classes.tableCell} align="center">
                              Total
                              <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                            </TableCell>
                            <TableCell className={classes.tableCell} align="center">
                              connected
                              <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                            </TableCell>
                            <TableCell className={classes.tableCell} align="center">
                              Missed
                              <img className={classes.addIcon} src={ArrowIcon} alt="arrow" />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {clsDeptName && clsDeptName.map((item: any) => {
                          return (
                            <>
                              <TableHead className={classes.tableHeader}>
                                <TableRow>
                                  <TableCell className={classes.tableCellRow}>
                                    <div style={{ display: "flex", alignItems: 'center', cursor: "pointer", gap: 5 }}>
                                      <HiArrowNarrowRight style={{ color: '#4D72F8', cursor: 'pointer' }}
                                        onClick={() => postData(item._id, item.incomingDeptStats, item.outgoingDeptStats)}
                                      />
                                      <div style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}>
                                        {item.name}
                                        {childRow && id === item.name ? (
                                          <KeyboardArrowUp onClick={() => handleCloseChildRow(item.name)} />
                                        ) : (
                                          <KeyboardArrowDown onClick={() => handleCloseChildRow(item.name)} />
                                        )}
                                      </div>
                                    </div>
                                  </TableCell>
                                  <TableCell className={classes.tableCellRow} align="center"
                                    onClick={() => closeHoursOutgoingNextPage(item._id, item.outgoingDeptStats, 1, 0)}
                                  >
                                    {item.outgoingDeptStats?.total}
                                  </TableCell>
                                  <TableCell className={classes.tableCellRow} align="center"
                                    onClick={() => closeHoursOutgoingNextPage(item._id, item.outgoingDeptStats, 0, 1)}
                                  >
                                    {item.outgoingDeptStats?.connected}
                                  </TableCell>
                                  <TableCell className={classes.tableCellRow} align="center"
                                    onClick={() => closeHoursIncomingRedirectNextPage(item._id, item.incomingDeptStats, 1, 0)}
                                  >
                                    {item.incomingDeptStats?.total}
                                  </TableCell>
                                  <TableCell className={classes.tableCellRow} align="center"
                                    onClick={() => closeHoursIncomingRedirectNextPage(item._id, item.incomingDeptStats, 0, 1)}
                                  >
                                    {item.incomingDeptStats?.connected}
                                  </TableCell>
                                  <TableCell className={classes.tableCellRow} align="center">
                                    {item.incomingDeptStats?.missed}
                                    {/* <img className={classes.addIcon} src={ArrowIcon} alt="arrow" /> */}
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              {childCloseRow && (id === item.name) &&
                                <TableBody>
                                  {item.userStats && item.userStats.map((detail: any) => {
                                    return (
                                      <>
                                        <TableRow key={detail.name}>
                                          <TableCell className={classes.tableCellBody}>{detail.firstName} {detail.lastName}</TableCell>
                                          <TableCell className={classes.tableCellBody}>{detail?.outgoingStats?.total}</TableCell>
                                          <TableCell className={classes.tableCellBody}>
                                            <div>
                                              {detail?.outgoingStats?.connected}

                                              <div>
                                                <Typography style={{ color: "gray", fontSize: "9px" }}>{detail.outgoingDeptStats?.outboundDuration}</Typography>
                                              </div>
                                            </div>
                                          </TableCell>
                                          <TableCell className={classes.tableCellBody}>{detail.incomingStats?.total}</TableCell>
                                          <TableCell className={classes.tableCellBody}>
                                            <div>
                                              {detail.incomingStats?.connected}

                                              <div>
                                                <Typography style={{ color: "gray", fontSize: "9px" }}>{detail.incomingStats?.inboundDuration}</Typography>
                                              </div>
                                            </div>
                                          </TableCell>
                                          <TableCell className={classes.tableCellBody}>  {detail.incomingStats?.missed}</TableCell>
                                        </TableRow>


                                      </>
                                    );
                                  })}
                                  {clsDeptName?.length <= 0 &&
                                    <p style={{ textAlign: "center", fontSize: 14, fontWeight: 400, marginTop: 10 }}> No Data found</p>}
                                </TableBody>}
                            </>
                          )
                        })}
                        {clsDeptName?.length > 0 && <TableHead className={classes.tableHead}>
                          <TableRow>
                            <TableCell className={classes.tableCellRow} align="center">
                              Summary
                            </TableCell>
                            <TableCell className={classes.tableCellRow} align="center">
                              {closeSummary?.totalOutbound}
                            </TableCell>
                            <TableCell className={classes.tableCellRow} align="center">
                              {closeSummary?.totalOutboundConnected}
                            </TableCell>
                            <TableCell className={classes.tableCellRow} align="center">
                              {closeSummary?.totalInbound}
                            </TableCell>
                            <TableCell className={classes.tableCellRow} align="center">
                              {closeSummary?.totalInboundConnected}
                            </TableCell>
                            <TableCell className={classes.tableCellRow} align="center">
                              {closeSummary?.totalMissedCalls}
                            </TableCell>
                          </TableRow>

                        </TableHead>
                        }

                      </Table>
                      {clsDeptName?.length <= 0 &&
                        <p style={{ textAlign: "center", fontSize: 14, fontWeight: 500, marginTop: 10 }}> No Data found</p>
                      }
                    </TableContainer>
                  </CardContent> : ""}
          </>
        }
      </Card>
    </>
  );
}
